import {
  Backdrop,
  CircularProgress,
  createStyles,
  makeStyles,
  Theme
} from '@material-ui/core';
import React, { memo } from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff'
    }
  })
);

export const LoadingPage = memo(({ isOpen = true }: { isOpen?: boolean }) => {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={isOpen}>
      <CircularProgress color='inherit' />
    </Backdrop>
  );
});

LoadingPage.displayName = 'LoadingPage';
